import { AuthApp } from "components/auth-app";
import { CoverageContextProvider } from "pages/overview/extended-coverages/hooks";

const AuthAppWrapper = () => (
  <CoverageContextProvider>
    <AuthApp />
  </CoverageContextProvider>
);

export default AuthAppWrapper;
